export function Dash() {
  return (
    <span
      className="text-muted"
      title="Estação em manutenção — sem leituras"
      aria-label="sem leitura — estação em manutenção"
    >
      —
    </span>
  );
}
